import { sanitizeDisplayText } from "@/shared/lib/safe-text";

/** Characters of an id shown to tell same-named records apart. */
const ID_SUFFIX_LENGTH = 4;

/** `#` + the tail of an id: the cheap tie-breaker for names that are not unique. */
export function shortId(id: string): string {
  return `#${id.slice(-ID_SUFFIX_LENGTH)}`;
}

const nameKey = (name: string) => sanitizeDisplayText(name).toLocaleLowerCase();

/**
 * Ids of the items whose (readable) name another item of the list shares, so
 * only those get a secondary label. The location payload carries no address.
 * Nameless items are never "duplicates": they already show their id.
 */
export function idsWithSharedName(
  items: readonly { readonly id: string; readonly name: string }[],
): ReadonlySet<string> {
  const counts = new Map<string, number>();
  for (const item of items) {
    const key = nameKey(item.name);
    if (key) counts.set(key, (counts.get(key) ?? 0) + 1);
  }
  return new Set(
    items.filter((item) => (counts.get(nameKey(item.name)) ?? 0) > 1).map((item) => item.id),
  );
}
